module.exports = __webpack_public_path__ + "img/jubao.7d5d3b38.png";